import { h } from 'preact';

import { preactDynamicComponent } from 'common/module/preact/dynamic/component';
import { BuildingReviewLandingFormService } from 'common/service/building-review-landing-form/service';
import { BuildingReviewLandingFormTemplate } from 'desktop/module/building-review-landing/form/template';

const BuildingReviewLandingForm = preactDynamicComponent(BuildingReviewLandingFormTemplate);
BuildingReviewLandingFormService().initialize();

export const BuildingReviewLandingFormComponent = () => (
  <BuildingReviewLandingForm viewStore={BuildingReviewLandingFormService()} />
);
